export enum Intensity {
  Light = 'Light',
  Medium = 'Medium',
  DeepNill = 'Deep',
  Nill = 'Nil',
}
